import React, { useEffect } from "react";

export type QrResult = {
  result?: string;
  isLoading: boolean;
  errorMessage?: string;
};

export default function useQr({
  open,
}: {
  open: (message: string) => void;
}): [QrResult, () => void] {
  const [result, setResult] = React.useState<QrResult>({
    isLoading: true,
  });

  const qrCall = function () {
    setResult((prev) => ({ isLoading: true }));
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.qr) {
        window.SANDI.qr();
      } else {
        open("사용중인 기기는\nQR 기능을 지원하지 않습니다.");
        setResult({ isLoading: false });
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      window.webkit?.messageHandlers.qr.postMessage("qr");
    } else {
      open("모바일 기기에서 시도해주세요.");
      setResult({ isLoading: false });
    }
  };

  const handleQR = function (qrJson: string) {
    const result = typeof qrJson === "string" ? qrJson : JSON.stringify(qrJson);
    setResult({
      result,
      isLoading: false,
      errorMessage: typeof qrJson,
    });
  };

  useEffect(() => {
    window.handleQR = handleQR;
  }, []);

  return [result, qrCall];
}
